class GiftBoxItem extends HTMLElement {
  constructor() {
    super();
    this.buttonAddToCart = this.querySelector('.gift-box__add-to-cart');
    this.variantId = 47686820004157;
    this.threshold = 100;
  }

  connectedCallback() {
    this.buttonAddToCart.addEventListener('click', this.addToCart.bind(this));
    document.addEventListener('cart:updated', this.autoAddGiftBox.bind(this));
  }

  autoAddGiftBox(e) {
    return;
    const { cart } = e.detail;
    const isTotalGreaterThanThreshold = cart.total_price >= this.threshold * 100; // Shopify's total_price is in cents
    const isVariantInCart = cart.items.some(item => item.variant_id === this.variantId);
    if (isTotalGreaterThanThreshold && !isVariantInCart) {
      this.buttonAddToCart.click();
    }
  }

  addToCart(e) {
    e.preventDefault();
    addToCart({
      id: this.variantId,
      quantity: 1
    });
  }
}

window.customElements.define("gift-box-item", GiftBoxItem);